import React, { useMemo } from 'react';
import { FormGroup, Label } from "reactstrap";
import { Controller } from "react-hook-form";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const QuillEditor = ({
  fieldName,
  control,
  fieldLabel,
  placeholder,
  error,
  disabled,
  readOnly,
  modules,
  formats
}) => {
  // Default modules configuration
  const defaultModules = useMemo(() => ({
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['link'],
      ['clean']
    ],
    clipboard: {
      matchVisual: false,
    }
  }), []);

  // Default formats
  const defaultFormats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'color', 'background',
    'align',
    'link', 'image'
  ];

  return (
    <>
      <FormGroup>
        <Label
          htmlFor={fieldName}
          className="col-form-label"
        >
          {fieldLabel}
        </Label>
        <Controller
          name={fieldName}
          control={control}
          render={({ field: { onChange, value } }) => (
            <div style={{
              backgroundColor: disabled || readOnly ? '#f5f5f5' : '#fff',
              borderRadius: '4px'
            }}>
              <ReactQuill
                theme="snow"
                value={value || ''}
                onChange={onChange}
                placeholder={placeholder}
                readOnly={readOnly || disabled}
                modules={modules || defaultModules}
                formats={formats || defaultFormats}
                style={{
                  backgroundColor: disabled || readOnly ? '#f5f5f5' : '#fff',
                  borderRadius: '4px'
                }}
              />
            </div>
          )}
        />
        {error && (
          <p
            role="alert"
            style={{
              color: "red",
              display: "flex",
              flexDirection: "start",
              paddingLeft: "10px",
              fontSize: "12px",
              marginTop: "5px"
            }}
          >
            {error?.message}
          </p>
        )}
      </FormGroup>
    </>
  );
};

export default QuillEditor;
